import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosapi from "../utilities/axiosApi";

export const fetchAllCutomers = createAsyncThunk("customer/fetchAllCutomers", async ({offset, limit, search},{ rejectWithValue }) => {
    try{
        const response = await axiosapi.get("api/admin/customer",{
            params:{offset, limit, search},
        });
        return response.data;
    }catch (err) {
        console.error("GET API Error:", err); 
        return rejectWithValue(err.response.data);  
    }
})

export const changeCutomerPassword = createAsyncThunk("customer/changeCutomerPassword", async (data,{ rejectWithValue }) => { 
    try{
        const response = await axiosapi.post("api/admin/change-customer-password",data);
        return response.data;
    }catch (err) {
        console.error("GET API Error:", err); 
        return rejectWithValue(err.response.data);  
    }
})

const customerSlice = createSlice({
    name:"customer",
    initialState:{
       allCustomers:[],
       loader:false,
       changePassword:{}
    },
    reducers:{},
    extraReducers:(builder) => {
        builder
        // All customer list
        .addCase(fetchAllCutomers.pending, (state, action) => {
           state.loader = true;
        })
        .addCase(fetchAllCutomers.fulfilled, (state, action) => {
            state.loader = false;
            state.allCustomers = action.payload?.data || []
         })
         .addCase(fetchAllCutomers.rejected, (state, action) => {
            state.loader = false;
         })
        // Change password
         .addCase(changeCutomerPassword.pending, (state, action) => {
            state.loader = true;
        })
        .addCase(changeCutomerPassword.fulfilled, (state, action) => {
            state.loader = false;
            state.changePassword = action.payload?.data;
        })
        .addCase(changeCutomerPassword.rejected, (state, action) => {
            state.loader = false;
        })
    }
})

export default customerSlice.reducer;